import { render, staticRenderFns } from "./StatusModel.vue?vue&type=template&id=dfc9c2ce&scoped=true&"
import script from "./StatusModel.vue?vue&type=script&lang=js&"
export * from "./StatusModel.vue?vue&type=script&lang=js&"
import style0 from "./StatusModel.vue?vue&type=style&index=0&id=dfc9c2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc9c2ce",
  null
  
)

export default component.exports